import { render, staticRenderFns } from "./Colophon.vue?vue&type=template&id=5dfff3b4&scoped=true"
import script from "./Colophon.vue?vue&type=script&lang=js"
export * from "./Colophon.vue?vue&type=script&lang=js"
import style0 from "./Colophon.vue?vue&type=style&index=0&id=5dfff3b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfff3b4",
  null
  
)

export default component.exports